import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var chevron_up_down_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "m12 20-4.5-3.6-.9 1.2L12 22l5.5-4.4-.9-1.2L12 20zm0-16 4.5 3.6.9-1.2L12 2 6.5 6.4l.9 1.2L12 4z" }) });
export {
  chevron_up_down_default as default
};
//# sourceMappingURL=chevron-up-down.js.map
